<template>
  <form-dialog v-model="isActive"
               :sending="sending"
               max-width="800"
               :title="edit ? $t('tecnici.azioni.modifica') :$t('tecnici.azioni.nuovo')"
               @confirm="onConfirm">

    <v-flex class="shrink">
      <avatar-input v-model="files.immagine_profilo" :preview="form.immagine_profilo" size="65"/>
    </v-flex>

    <v-flex class="grow">
      <text-field :label="$t('label.nome')" v-model="form.nome" required/>
    </v-flex>

    <v-flex xs12 sm4>
      <text-field :label="$t('label.cognome')" v-model="form.cognome" required/>
    </v-flex>
    <!--
    <v-flex xs12 sm3>
      <text-field :label="$t('label.codice')" v-model="form.codice"/>
    </v-flex>
    -->
    <v-flex xs12 sm6 class="pl-5">
      <text-field
        :label="$t('tecnici.label.username')"
        v-model="form.username"
        prepend-icon="mail"
        required
        show-details
        :readonly="edit"
        :disabled="edit"
        :v-rules="[$utils.rules.email]"/>
    </v-flex>

    <v-flex xs12 sm6>
      <phone-field :label="$t('label.telefono')" v-model="form.telefono" show-details/>
    </v-flex>

    <v-flex xs12 sm6>
      <image-input
        :label="$t('tecnici.label.scansione_firma')"
        class="ml-5"
        v-model="files.scansione_firma"
        :preview="edit && form.id > 0 ? $api.tecnici.getFirmaUrl(form.id) : null"
        :hint="$t('tecnici.label.scansione_firma_info')"
        required/>
    </v-flex>

    <v-flex xs12 sm6 v-if="edit">
      <v-btn color="accent" round flat block @click="onStatsClick">{{ $t('tecnici.label.apri_stats') }}</v-btn>
      <v-btn color="warning" round flat block @click="onResetPKClick">{{ $t('tecnici.label.reset_product_key') }}</v-btn>
    </v-flex>

  </form-dialog>
</template>

<script>
import Sendable from '@/mixins/sendable'
import FormDialog from '@/components/base/FormDialog'
import { AvatarInput, ImageInput, PhoneField } from '@/components/inputs'

export default {
    name: 'TecnicoDialog',
    mixins: [Sendable],
    components: { FormDialog, AvatarInput, ImageInput, PhoneField },
    data () {
        return {
            defaultData: this.$schemas().tecnico,
            files: {
                immagine_profilo: null,
                scansione_firma: null
            }
        }
    },
    methods: {
        action () {
            if (this.edit) {
                return this.$api.tecnici.update(this.form.id, this.computedForm)
            } else {
                return this.$api.tecnici.create(this.computedForm)
            }
        },
        afterReset () {
            this.files.immagine_profilo = null
            this.files.scansione_firma = null
        },
        onStatsClick () {
            this.$emit('click:stats', this.form)
        },
        onResetPKClick () {
            this.$confirmDialog.show(
                this.form.username,
                this.$t('tecnici.messaggi.conferma_reset_product_key'),
                (username) => {
                    this.$api.tecnici.resetProductKey(username).then(() => {
                        this.onSuccess(this.$t('tecnici.messaggi.reset_product_key'))
                    }).catch(e => {
                        this.onError()
                    })
                }, { color: 'warning' })
        },
        onConfirm () {
            this.sending = true
            this.action()
                .then(() => {
                    this.onSuccess(this.edit ? this.$t('tecnici.messaggi.modificato') : this.$t('tecnici.messaggi.creato'))
                    if(!this.edit) this.afterReset()
                    else  this.files.immagine_profilo = null
                }).catch(e => {
                    if (e.response && e.response.data && (e.response.status === 400 || e.response.status === 401 || e.response.status === 402)) {
                        if (e.response.data.message === 'regenerate') {
                            this.sending = false
                            //  E' già stato creato un tecnico con questo username, mostro la conferma di ripristino
                            this.$confirmDialog.show(
                                this.form.username,
                                this.$t('tecnici.messaggi.conferma_ripristino_duplicato'),
                                (username) => {
                                    this.$api.tecnici.restore(username).then(() => {
                                        this.onSuccess(this.$t('tecnici.messaggi.ripristinato'))
                                    })
                                }, { confirmText: this.$t('azioni.ripristina'), color: 'error' })
                        } else if (e.response.data.message === 'used') {
                            this.onError(this.$t('tecnici.errori.username_duplicato'))
                        } else if (e.response.data.message === 'level_abbonamento') {
                            this.onError(this.$t('tecnici.errori.limite_tecnici_raggiunto'))
                        } else {
                            this.onError(this.$t('errori.server'))
                        }
                    } else {
                        this.onError(this.$t('errori.server'))
                    }
                })
        }
    },
    computed: {
        computedForm () {
            let computedForm = new FormData()
            computedForm.append('nome', this.form.nome)
            computedForm.append('cognome', this.form.cognome)
            computedForm.append('codice', this.form.codice)
            computedForm.append('username', this.form.username)
            computedForm.append('telefono', this.form.telefono)
            if (this.files.immagine_profilo !== null) {
                computedForm.append('immagine_profilo', this.files.immagine_profilo)
            }
            if (this.files.scansione_firma !== null) {
                computedForm.append('scansione_firma', this.files.scansione_firma)
            }
            return computedForm
        }
    }
}
</script>
